import {
    TOOL_SELECTION,
    KEY_CODE_CTRL,
    KEY_CODE_ARROW_UP,
    KEY_CODE_ARROW_LEFT,
    KEY_CODE_ARROW_RIGHT,
    KEY_CODE_ARROW_DOWN,
    KEY_CODE_DELETE,
    KEY_CODE_C,
    KEY_CODE_V,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import {
    OBJECT_MOVEMENT_SPEED,
    OBJECT_MOVEMENT_MODIFIER_MULTIPLIER,
} from '%paysera_seat_selection/js/seatSelection/config/defaults';
import {
    moveSelectedObjects,
    selectSnapToGrid,
    selectGridSize,
    selectModifierKeys,
    deleteSelectedObjects,
    copyToClipboard,
    pasteFromClipboard,
} from '%paysera_seat_selection/js/seatSelection/redux';
import doKeyDown from './original/keyDown';
import selectSelection from '%paysera_seat_selection/js/seatSelection/redux/component/workflow/selectors/selectSelection';
import moveViewBox from '%paysera_seat_selection/js/seatSelection/redux/component/workflow/actions/moveViewBox';
import { SELECTION_SCOPE_HALL } from '%paysera_seat_selection/js/seatSelection/constants/selectionScope';

const getMoveCoordinates = (payload, speed, objects, scope) => {
    const start = { x: 0, y: 0 };
    let end = { x: 0, y: 0 };
    if (scope === SELECTION_SCOPE_HALL) {
        if (payload === KEY_CODE_ARROW_UP) {
            end = { x: 0, y: -speed };
        }
        if (payload === KEY_CODE_ARROW_LEFT) {
            end = { x: -speed, y: 0 };
        }
        if (payload === KEY_CODE_ARROW_RIGHT) {
            end = { x: speed, y: 0 };
        }
        if (payload === KEY_CODE_ARROW_DOWN) {
            end = { x: 0, y: speed };
        }
    }

    return { start, end };
};

const isMovementKeyPressed = keyCode => [
    KEY_CODE_ARROW_UP,
    KEY_CODE_ARROW_LEFT,
    KEY_CODE_ARROW_RIGHT,
    KEY_CODE_ARROW_DOWN,
].includes(keyCode);

function keyDown(payload, event) {
    return (dispatch, getState) => {
        if (
            event instanceof KeyboardEvent
            && ['INPUT', 'TEXTAREA'].includes(event.target.nodeName)
        ) {
            return;
        }

        dispatch(doKeyDown(payload));

        if (payload === KEY_CODE_DELETE) {
            dispatch(deleteSelectedObjects());
            return;
        }

        const { objects, scope } = selectSelection(getState());
        const { seat_selection: { workflow: { currentTool, modifierKeys } } } = getState();

        if (modifierKeys.includes(KEY_CODE_CTRL)) {
            if (payload === KEY_CODE_C) {
                dispatch(copyToClipboard({ objects }));
            }
            if (payload === KEY_CODE_V) {
                dispatch(pasteFromClipboard());
            }
        }

        if (!isMovementKeyPressed(payload)) {
            return;
        }

        let speed = selectSnapToGrid(getState()) ? selectGridSize(getState()) : OBJECT_MOVEMENT_SPEED;

        if (modifierKeys.includes(KEY_CODE_CTRL)) {
            speed *= OBJECT_MOVEMENT_MODIFIER_MULTIPLIER;
        }

        const coordinates = getMoveCoordinates(payload, speed, objects, scope);

        if (objects.length === 0) {
            dispatch(moveViewBox(coordinates.end));
        }
        if (objects.length > 0 && currentTool === TOOL_SELECTION) {
            dispatch(moveSelectedObjects(coordinates));
        }
    };
}

export default keyDown;
